import { get } from "../common/apiClient";

const PATH_EXAM = "/exam";

/**
 * Get all exams with pagination
 * @param {Object} params - { page, limit, query }
 * @returns {Promise} - { data, totalItemsExam, totalPages, currentPage }
 */
export const getExams = async (params = {}) => {
  const { page = 1, limit = 6, query = "" } = params;
  const queryString = new URLSearchParams({ page, limit, query }).toString();
  return await get(`${PATH_EXAM}?${queryString}`);
};

/**
 * Get exam by ID
 * @param {string} examId
 * @returns {Promise}
 */
export const getExamById = async (examId) => {
  return await get(`${PATH_EXAM}/${examId}`);
};
